import { roundDecimalNumber } from './round-decimal-number';

/**
 * Format price with dollar sign, space, comma separators, and two decimal places
 * Rounds to the nearest 0.10 (dime) before formatting
 * Example: formatPrice(3269.56) => "$ 3,269.60"
 *
 * @param {number} price - The price to format
 * @return {string} Formatted price string
 */
export const formatPrice = (price: number): string => {
  const roundedPrice = roundDecimalNumber(price, 1);
  
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return `$ ${formatter.format(roundedPrice)}`;
};

